import {inject, injectable} from 'inversify';

import type {CourseExpandFieldsCommon} from '../../../../api/course';
import type {Expand} from '../../../../api/types';

import {courseExpandCommon} from '../../../../api/course';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class CourseExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = courseExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace CourseExpandJrpc {
  export type ExpandedFields = CourseExpandFieldsCommon;
}
